<!-- story-highlight.component.html -->
<div class="string-highlighter-container">

  <!-- Error message if any -->
  <div *ngIf="error" class="error-message">
    {{ error }}
  </div>

  <!-- Main content area: Display content using processed segments -->
  <!-- Use a <pre> tag wrapping the spans to preserve whitespace and allow scrolling -->
  <div class="content-container" *ngIf="processedSegments.length > 0">
     <pre class="highlighted-content"> <!-- Wrap spans in pre -->
       <span *ngFor="let segment of processedSegments"
             [ngClass]="{
               'highlighted': segment.isHighlighted,
               'selected': selectedSegment?.id === segment.id,
               'clickable': segment.isHighlighted
             }"
             (click)="segment.isHighlighted && selectSegment(segment)">{{ segment.text }}</span>
     </pre> <!-- End pre tag -->

    <!-- Side panel showing info for selected highlight -->
    <!-- This panel will only appear if a highlighted segment with ambiguity info is clicked -->
    <div class="side-panel" *ngIf="selectedSegment && selectedSegment.ambiguity">
      <div class="panel-header">
        <h3>Ambiguity Information</h3>
        <button class="close-btn" aria-label="Close ambiguity details" (click)="closeSidePanel()">×</button>
      </div>
      <div class="panel-content">
        <!-- Displaying the details of the selected ambiguity -->
        <div class="segment-text">
          <h4>Description</h4>
          <p>{{ selectedSegment.ambiguity.description }}</p>
        </div>

        <div class="ambiguity-info">
          <div class="clarification">
            <h4>Clarification Needed</h4>
            <p>{{ selectedSegment.ambiguity.clarification_needed }}</p>
          </div>

          <div class="impact">
            <h4>Impact</h4>
            <!-- Apply dynamic class based on impact level -->
            <p [ngClass]="getImpactClass(selectedSegment.ambiguity.impact)">
              {{ selectedSegment.ambiguity.impact }}
            </p>
          </div>

          <div class="resolution" *ngIf="selectedSegment.ambiguity.resolution">
            <h4>Resolution</h4>
            <p>{{ selectedSegment.ambiguity.resolution }}</p>
          </div>
        </div>
      </div>
    </div> <!-- End side-panel -->
  </div> <!-- End content-container -->

  <!-- Optional: Message shown if there's absolutely no string content to process -->
  <div *ngIf="!originalString && !isLoading && processedSegments.length === 0" class="no-content-message">
    <p>No content available to display.</p>
  </div>

</div> <!-- End string-highlighter-container -->
